import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionGamma/details/pageContext';

type Result = ModelHookResult<{
	isSunriseEnabled: boolean;
}>;

/**
 * @deprecated use useIsFullSunriseEnabled instead
 */
export const useIsSunriseEnabled = (): Result => {
	const { data } = usePetitionDetailsPageUserData();
	return {
		data: {
			isSunriseEnabled: data.isSunriseEnabled,
		},
	};
};
